import 'core-js/stable'
import './polyfills.js'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

import * as VueGoogleMaps from 'vue2-google-maps'
import * as firebase from 'firebase'
import VueMeta from 'vue-meta'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueMeta)
Vue.prototype.$log = console.log.bind(console)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB0HallUdKrDaPKPDfS5HCeBjgH2va6Qxs',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
